module.exports = __webpack_public_path__ + "img/clock.06412bd8.svg";